import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout } from '@mopla/ui';

import { usePassengerAppNavigate } from '../../../hooks';
import {
	DTicketCancelSuccessModal,
	useDTicketSubscriptionRevoke,
} from '../dticketSubscriptionCancel';

import { useDTicketSubscriptionEditConfig } from './hooks/useDTicketSubscriptionEditConfig';
import { DTicketSubscriptionEditContent } from './DTicketSubscriptionEditContent';
import { DTicketSubscriptionEditSkeleton } from './DTicketSubscriptionEditSkeleton';

export const DTicketSubscriptionEdit = () => {
	const { t } = useTranslation('dticketSubscriptionEdit');

	const {
		navigateToUserDTicket,
		navigateToSubscriptionPause,
		navigateToSubscriptionCancel,
	} = usePassengerAppNavigate();

	const {
		isRevokeLoading,
		isSuccessModalOpen,
		handleRevoke,
		closeSuccessModal,
	} = useDTicketSubscriptionRevoke();

	const { isLoading, config } = useDTicketSubscriptionEditConfig({
		navigateToSubscriptionPause,
		navigateToSubscriptionCancel,
		onRevoke: handleRevoke,
	});

	useEffect(() => {
		if (!isLoading && !config) {
			navigateToUserDTicket();
		}
	}, [isLoading, config, navigateToUserDTicket]);

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={t('page_title')}
				onBack={navigateToUserDTicket}
				scrollable={true}
				dataTestId="dticket-editSubscription-page"
			>
				{isLoading || !config ? (
					<DTicketSubscriptionEditSkeleton />
				) : (
					<DTicketSubscriptionEditContent
						config={config}
						isRevokeLoading={isRevokeLoading}
					/>
				)}
			</DTicketPageLayout>

			{config && (
				<DTicketCancelSuccessModal
					open={isSuccessModalOpen}
					onClose={closeSuccessModal}
					variant="revoke"
					dates={config.dates}
				/>
			)}
		</ThemeProvider>
	);
};
